import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const ServicescredentialDeleteModal = lazy(() => import('./servicescredentialDeleteModal'));
const ServicescredentialAdd = lazy(() => import('./servicescredentialAdd'));
const ServicescredentialEdit = lazy(() => import('./servicescredentialEdit'));
const ServicescredentialsslcertificateDeleteModal = lazy(() => import('./servicescredentialsslcertificateDeleteModal'));
const ServicescredentialsslcertificateAdd = lazy(() => import('./servicescredentialsslcertificateAdd'));
const ServicescredentialsslcertificateEdit = lazy(() => import('./servicescredentialsslcertificateEdit'));
const ServiceskerberoscapathsDeleteModal = lazy(() => import('./serviceskerberoscapathsDeleteModal'));
const ServiceskerberoscapathsAdd = lazy(() => import('./serviceskerberoscapathsAdd'));
const ServiceskerberoscapathsEdit = lazy(() => import('./serviceskerberoscapathsEdit'));
const ServiceskerberoscapathsrealmsDeleteModal = lazy(() => import('./serviceskerberoscapathsrealmsDeleteModal'));
const ServiceskerberoscapathsrealmsAdd = lazy(() => import('./serviceskerberoscapathsrealmsAdd'));
const ServiceskerberoscapathsrealmsEdit = lazy(() => import('./serviceskerberoscapathsrealmsEdit'));
const ServiceskerberoslibdefaultspropertiesDeleteModal = lazy(() => import('./serviceskerberoslibdefaultspropertiesDeleteModal'));
const ServiceskerberoslibdefaultspropertiesAdd = lazy(() => import('./serviceskerberoslibdefaultspropertiesAdd'));
const ServiceskerberoslibdefaultspropertiesEdit = lazy(() => import('./serviceskerberoslibdefaultspropertiesEdit'));
const ServiceskerberosrealmsDeleteModal = lazy(() => import('./serviceskerberosrealmsDeleteModal'));
const ServiceskerberosrealmsAdd = lazy(() => import('./serviceskerberosrealmsAdd'));
const ServiceskerberosrealmsEdit = lazy(() => import('./serviceskerberosrealmsEdit'));
const ServiceskerberosrealmspropertiesDeleteModal = lazy(() => import('./serviceskerberosrealmspropertiesDeleteModal'));
const ServiceskerberosrealmspropertiesAdd = lazy(() => import('./serviceskerberosrealmspropertiesAdd'));
const ServiceskerberosrealmspropertiesEdit = lazy(() => import('./serviceskerberosrealmspropertiesEdit'));
const ServicesrediscollectionsDeleteModal = lazy(() => import('./servicesrediscollectionsDeleteModal'));
const ServicesrediscollectionsAdd = lazy(() => import('./servicesrediscollectionsAdd'));
const ServicesrediscollectionsEdit = lazy(() => import('./servicesrediscollectionsEdit'));
const ServicesrediscollectionsserversDeleteModal = lazy(() => import('./servicesrediscollectionsserversDeleteModal'));
const ServicesrediscollectionsserversAdd = lazy(() => import('./servicesrediscollectionsserversAdd'));
const ServicesrediscollectionsserversEdit = lazy(() => import('./servicesrediscollectionsserversEdit'));
const ServicesrediscollectionsserverssslclientCertificateDeleteModal = lazy(() => import('./servicesrediscollectionsserverssslclient_certificateDeleteModal'));
const ServicesrediscollectionsserverssslclientCertificateAdd = lazy(() => import('./servicesrediscollectionsserverssslclient_certificateAdd'));
const ServicesrediscollectionsserverssslclientCertificateEdit = lazy(() => import('./servicesrediscollectionsserverssslclient_certificateEdit'));
const ServicesrediscollectionsserversssltrustCertificatesDeleteModal = lazy(() => import('./servicesrediscollectionsserversssltrust_certificatesDeleteModal'));
const ServicesrediscollectionsserversssltrustCertificatesAdd = lazy(() => import('./servicesrediscollectionsserversssltrust_certificatesAdd'));
const ServicesrediscollectionsserversssltrustCertificatesEdit = lazy(() => import('./servicesrediscollectionsserversssltrust_certificatesEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    var newkerberos = {};
    if(document.getElementById("services_kerberos_keytab_id").value.endsWith(":") !== true) {
    newkerberos["keytab"] = document.getElementById("services_kerberos_keytab_id").value;
    }
    if(document.getElementById("services_kerberos_keytab_spn_id").value.endsWith(":") !== true) {
    newkerberos["keytab_spn"] = document.getElementById("services_kerberos_keytab_spn_id").value;
    }
    var newlibdefaults = {};
    newlibdefaults["properties"] = services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties;
    newkerberos["libdefaults"] = newlibdefaults;
    newkerberos["realms"] = services_kerberos_realmsrowData.services_kerberos_realms;
    newkerberos["capaths"] = services_kerberos_capathsrowData.services_kerberos_capaths;
    newkerberos["properties"] = services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties;
    newElem["kerberos"] = newkerberos;
    var newredis = {};
    if(document.getElementById("services_redis_default_collection_id").value.endsWith(":") !== true) {
    newredis["default_collection"] = document.getElementById("services_redis_default_collection_id").value;
    }
    if(document.getElementById("services_redis_key_prefix_id").value.endsWith(":") !== true) {
    newredis["key_prefix"] = document.getElementById("services_redis_key_prefix_id").value;
    }
    newredis["collections"] = services_redis_collectionsrowData.services_redis_collections;
    newElem["redis"] = newredis;
    newElem["credential"] = services_credentialrowData.services_credential;
    newElem["realms"] = services_kerberos_realmsrowData.services_kerberos_realms;
    newElem["collections"] = services_redis_collectionsrowData.services_redis_collections;
    newElem["capaths"] = services_kerberos_capathsrowData.services_kerberos_capaths;
    newElem["properties"] = services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties;
    json["services"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("services_div" + idPrefix, "display", "block");
      document.getElementById("services_tab" + idPrefix).style.display = "flex";

  };

const services_credentialheaderData = [
    {
    header: 'Encryption Key',
    key: 'enc_key',
  },
{
    header: 'Host',
    key: 'host',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Port',
    key: 'port',
  },
{
    header: 'Proxy',
    key: 'proxy',
  },
{
    header: 'URL Pattern',
    key: 'url_pattern',
  },
{
    header: 'User Attribute',
    key: 'user_attribute',
  },
{
    header: 'User Attribute Encoding',
    key: 'user_attribute_encoding',
  },

];

const services_credentialrowData = {services_credential: []};

const services_credentialhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_credential_authentication_access_token_token_id" + idPrefix).value = "";
    document.getElementById("services_credential_authentication_ba_password_id" + idPrefix).value = "";
    document.getElementById("services_credential_authentication_ba_username_id" + idPrefix).value = "";
    document.getElementById("services_credential_authentication_sso_client_id_id" + idPrefix).value = "";
    document.getElementById("services_credential_authentication_sso_client_secret_id" + idPrefix).value = "";
    document.getElementById("services_credential_authentication_sso_endpoint_id" + idPrefix).value = "";
    document.getElementById("services_credential_authentication_sso_payload_id" + idPrefix).value = "";
    document.getElementById("services_credential_enc_key_id" + idPrefix).value = "";
    document.getElementById("services_credential_host_id" + idPrefix).value = "";
    document.getElementById("services_credential_name_id" + idPrefix).value = "";
    document.getElementById("services_credential_port_id" + idPrefix).value = "";
    document.getElementById("services_credential_proxy_id" + idPrefix).value = "";
    document.getElementById("services_credential_ssl_server_dn_id" + idPrefix).value = "";
    document.getElementById("services_credential_ssl_sni_id" + idPrefix).value = "";
    document.getElementById("services_credential_url_pattern_id" + idPrefix).value = "";
    document.getElementById("services_credential_user_attribute_id" + idPrefix).value = "";
    document.getElementById("services_credential_user_attribute_encoding_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addservices_credentialPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_credential_ssl_certificateheaderData = [
    {
    header: 'Certificate',
    key: 'certificate',
  },

];

const services_credential_ssl_certificaterowData = {services_credential_ssl_certificate: []};

const services_credential_ssl_certificatehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_credential_ssl_certificate_certificate_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addservicescredentialssl_certificatePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_kerberos_capathsheaderData = [
    {
    header: 'Client Realm',
    key: 'client_realm',
  },

];

const services_kerberos_capathsrowData = {services_kerberos_capaths: []};

const services_kerberos_capathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_kerberos_capaths_client_realm_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserviceskerberos_capathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_kerberos_capaths_realmsheaderData = [
    {
    header: 'Inter Realm',
    key: 'inter_realm',
  },
{
    header: 'Server Realm',
    key: 'server_realm',
  },

];

const services_kerberos_capaths_realmsrowData = {services_kerberos_capaths_realms: []};

const services_kerberos_capaths_realmshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_kerberos_capaths_realms_inter_realm_id" + idPrefix).value = "";
    document.getElementById("services_kerberos_capaths_realms_server_realm_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserviceskerberoscapaths_realmsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_kerberos_libdefaults_propertiesheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Value',
    key: 'value',
  },

];

const services_kerberos_libdefaults_propertiesrowData = {services_kerberos_libdefaults_properties: []};

const services_kerberos_libdefaults_propertieshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_kerberos_libdefaults_properties_name_id" + idPrefix).value = "";
    document.getElementById("services_kerberos_libdefaults_properties_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserviceskerberoslibdefaults_propertiesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_kerberos_realmsheaderData = [
    {
    header: 'Hostname',
    key: 'hostname',
  },
{
    header: 'KDC',
    key: 'kdc',
  },
{
    header: 'Name',
    key: 'name',
  },

];

const services_kerberos_realmsrowData = {services_kerberos_realms: []};

const services_kerberos_realmshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_kerberos_realms_hostname_id" + idPrefix).value = "";
    document.getElementById("services_kerberos_realms_kdc_id" + idPrefix).value = "";
    document.getElementById("services_kerberos_realms_name_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserviceskerberos_realmsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_kerberos_realms_propertiesheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Value',
    key: 'value',
  },

];

const services_kerberos_realms_propertiesrowData = {services_kerberos_realms_properties: []};

const services_kerberos_realms_propertieshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_kerberos_realms_properties_name_id" + idPrefix).value = "";
    document.getElementById("services_kerberos_realms_properties_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserviceskerberosrealms_propertiesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_redis_collectionsheaderData = [
    {
    header: 'Connect Timeout',
    key: 'connect_timeout',
  },
{
    header: 'Health Check Interval',
    key: 'health_check_interval',
  },
{
    header: 'Idle Timeout',
    key: 'idle_timeout',
  },
{
    header: 'IO Timeout',
    key: 'io_timeout',
  },
{
    header: 'Matching Host',
    key: 'matching_host',
  },
{
    header: 'Max Pooled Connections',
    key: 'max_pooled_connections',
  },
{
    header: 'Name',
    key: 'name',
  },

];

const services_redis_collectionsrowData = {services_redis_collections: []};

const services_redis_collectionshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_redis_collections_connect_timeout_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_cross_domain_support_master_authn_server_url_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_cross_domain_support_master_session_code_lifetime_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_health_check_interval_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_idle_timeout_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_io_timeout_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_matching_host_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_max_pooled_connections_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_name_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addservicesredis_collectionsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_redis_collections_serversheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Password',
    key: 'password',
  },
{
    header: 'Port',
    key: 'port',
  },
{
    header: 'Username',
    key: 'username',
  },

];

const services_redis_collections_serversrowData = {services_redis_collections_servers: []};

const services_redis_collections_servershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_redis_collections_servers_host_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_servers_name_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_servers_password_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_servers_port_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_servers_ssl_sni_id" + idPrefix).value = "";
    document.getElementById("services_redis_collections_servers_username_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addservicesrediscollections_serversPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_redis_collections_servers_ssl_client_certificateheaderData = [
    {
    header: 'Client Certificate',
    key: 'client_certificate',
  },

];

const services_redis_collections_servers_ssl_client_certificaterowData = {services_redis_collections_servers_ssl_client_certificate: []};

const services_redis_collections_servers_ssl_client_certificatehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_redis_collections_servers_ssl_client_certificate_client_certificate_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addservicesrediscollectionsserversssl_client_certificatePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };
const services_redis_collections_servers_ssl_trust_certificatesheaderData = [
    {
    header: 'Trust Certificate',
    key: 'trust_certificates',
  },

];

const services_redis_collections_servers_ssl_trust_certificatesrowData = {services_redis_collections_servers_ssl_trust_certificates: []};

const services_redis_collections_servers_ssl_trust_certificateshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("services_redis_collections_servers_ssl_trust_certificates_trust_certificates_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("services_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addservicesrediscollectionsserversssl_trust_certificatesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("services_tab" + idPrefix).style.display = "none";

  };


const ServicesPage = () => {

  const idPrefix = "";

  if(window.iagpage != "ServicesPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "ServicesPage";
  }

    const [services_credential, setservices_credential] = React.useState([]);
    const [fetchedservices_credential, setFetchedservices_credential] = React.useState(false);

    React.useEffect(() => {
      services_credentialloadGrid();
    }, [fetchedservices_credential]);

    const services_credentialloadGrid = React.useCallback(async (services_credential_authentication_access_token_token, services_credential_authentication_ba_password, services_credential_authentication_ba_username, services_credential_authentication_sso_client_id, services_credential_authentication_sso_client_secret, services_credential_authentication_sso_endpoint, services_credential_authentication_sso_payload, services_credential_enc_key, services_credential_host, services_credential_name, services_credential_port, services_credential_proxy, services_credential_ssl_server_dn, services_credential_ssl_sni, services_credential_url_pattern, services_credential_user_attribute, services_credential_user_attribute_encoding, services_credential_ssl_certificate,add) => {
      try {
        var attrs = [];
        if(services_credential_name) {
          if(add) {
            for(var i = 0; i < services_credentialrowData.services_credential.length; i++) {
              var tempId = ((services_credentialrowData.services_credential[i].name)?services_credentialrowData.services_credential[i].name:"") + "";
              if((window.services_credentialediting != true && window.services_credentialediting != "true") || tempId != window.services_credentialrowId) {
                attrs.push(services_credentialrowData.services_credential[i]);
              }
            }
            var newId = ((services_credential_name)?services_credential_name:"") + "";
            attrs.push({
              id: newId,
                  authentication: {
    access_token: {
token: services_credential_authentication_access_token_token,
    },
    ba: {
password: services_credential_authentication_ba_password,
username: services_credential_authentication_ba_username,
    },
    sso: {
client_id: services_credential_authentication_sso_client_id,
client_secret: services_credential_authentication_sso_client_secret,
endpoint: services_credential_authentication_sso_endpoint,
payload: services_credential_authentication_sso_payload,
    },
    },
enc_key: services_credential_enc_key,
host: services_credential_host,
name: services_credential_name,
port: services_credential_port,
proxy: services_credential_proxy,
    ssl: {
certificate: services_credential_ssl_certificate,
server_dn: services_credential_ssl_server_dn,
sni: services_credential_ssl_sni,
    },
url_pattern: services_credential_url_pattern,
user_attribute: services_credential_user_attribute,
user_attribute_encoding: services_credential_user_attribute_encoding,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_credentialrowData.services_credential.length; i++) {
              if(services_credentialrowData.services_credential[i].name !== services_credential_name ) {
                attrs.push(services_credentialrowData.services_credential[i]);
              }
            }
          }
        } else {
          attrs = services_credentialrowData.services_credential;
        }
        services_credentialrowData.services_credential = attrs;
        const data = {services_credential: attrs};
        setservices_credential(data.services_credential);

        if(services_credential_name !== undefined && services_credential_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_credential_ssl_certificate, setservices_credential_ssl_certificate] = React.useState([]);
    const [fetchedservices_credential_ssl_certificate, setFetchedservices_credential_ssl_certificate] = React.useState(false);

    React.useEffect(() => {
      services_credential_ssl_certificateloadGrid();
    }, [fetchedservices_credential_ssl_certificate]);

    const services_credential_ssl_certificateloadGrid = React.useCallback(async (services_credential_ssl_certificate_certificate, add) => {
      try {
        var attrs = [];
        if(services_credential_ssl_certificate_certificate) {
          if(add) {
            for(var i = 0; i < services_credential_ssl_certificaterowData.services_credential_ssl_certificate.length; i++) {
              var tempId = ((services_credential_ssl_certificaterowData.services_credential_ssl_certificate[i].certificate)?services_credential_ssl_certificaterowData.services_credential_ssl_certificate[i].certificate:"") + "";
              if((window.services_credential_ssl_certificateediting != true && window.services_credential_ssl_certificateediting != "true") || tempId != window.services_credential_ssl_certificaterowId) {
                attrs.push(services_credential_ssl_certificaterowData.services_credential_ssl_certificate[i]);
              }
            }
            var newId = ((services_credential_ssl_certificate_certificate)?services_credential_ssl_certificate_certificate:"") + "";
            attrs.push({
              id: newId,
              certificate: services_credential_ssl_certificate_certificate,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_credential_ssl_certificaterowData.services_credential_ssl_certificate.length; i++) {
              if(services_credential_ssl_certificaterowData.services_credential_ssl_certificate[i].certificate !== services_credential_ssl_certificate_certificate ) {
                attrs.push(services_credential_ssl_certificaterowData.services_credential_ssl_certificate[i]);
              }
            }
          }
        } else {
          attrs = services_credential_ssl_certificaterowData.services_credential_ssl_certificate;
        }
        services_credential_ssl_certificaterowData.services_credential_ssl_certificate = attrs;
        const data = {services_credential_ssl_certificate: attrs};
        setservices_credential_ssl_certificate(data.services_credential_ssl_certificate);

        if(services_credential_ssl_certificate_certificate !== undefined && services_credential_ssl_certificate_certificate !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_kerberos_capaths, setservices_kerberos_capaths] = React.useState([]);
    const [fetchedservices_kerberos_capaths, setFetchedservices_kerberos_capaths] = React.useState(false);

    React.useEffect(() => {
      services_kerberos_capathsloadGrid();
    }, [fetchedservices_kerberos_capaths]);

    const services_kerberos_capathsloadGrid = React.useCallback(async (services_kerberos_capaths_client_realm, services_kerberos_capaths_realms,add) => {
      try {
        var attrs = [];
        if(services_kerberos_capaths_client_realm) {
          if(add) {
            for(var i = 0; i < services_kerberos_capathsrowData.services_kerberos_capaths.length; i++) {
              var tempId = ((services_kerberos_capathsrowData.services_kerberos_capaths[i].client_realm)?services_kerberos_capathsrowData.services_kerberos_capaths[i].client_realm:"") + "";
              if((window.services_kerberos_capathsediting != true && window.services_kerberos_capathsediting != "true") || tempId != window.services_kerberos_capathsrowId) {
                attrs.push(services_kerberos_capathsrowData.services_kerberos_capaths[i]);
              }
            }
            var newId = ((services_kerberos_capaths_client_realm)?services_kerberos_capaths_client_realm:"") + "";
            attrs.push({
              id: newId,
              client_realm: services_kerberos_capaths_client_realm,
realms: services_kerberos_capaths_realms,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_kerberos_capathsrowData.services_kerberos_capaths.length; i++) {
              if(services_kerberos_capathsrowData.services_kerberos_capaths[i].client_realm !== services_kerberos_capaths_client_realm ) {
                attrs.push(services_kerberos_capathsrowData.services_kerberos_capaths[i]);
              }
            }
          }
        } else {
          attrs = services_kerberos_capathsrowData.services_kerberos_capaths;
        }
        services_kerberos_capathsrowData.services_kerberos_capaths = attrs;
        const data = {services_kerberos_capaths: attrs};
        setservices_kerberos_capaths(data.services_kerberos_capaths);

        if(services_kerberos_capaths_client_realm !== undefined && services_kerberos_capaths_client_realm !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_kerberos_capaths_realms, setservices_kerberos_capaths_realms] = React.useState([]);
    const [fetchedservices_kerberos_capaths_realms, setFetchedservices_kerberos_capaths_realms] = React.useState(false);

    React.useEffect(() => {
      services_kerberos_capaths_realmsloadGrid();
    }, [fetchedservices_kerberos_capaths_realms]);

    const services_kerberos_capaths_realmsloadGrid = React.useCallback(async (services_kerberos_capaths_realms_inter_realm, services_kerberos_capaths_realms_server_realm, add) => {
      try {
        var attrs = [];
        if(services_kerberos_capaths_realms_server_realm) {
          if(add) {
            for(var i = 0; i < services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms.length; i++) {
              var tempId = ((services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms[i].server_realm)?services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms[i].server_realm:"") + "";
              if((window.services_kerberos_capaths_realmsediting != true && window.services_kerberos_capaths_realmsediting != "true") || tempId != window.services_kerberos_capaths_realmsrowId) {
                attrs.push(services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms[i]);
              }
            }
            var newId = ((services_kerberos_capaths_realms_server_realm)?services_kerberos_capaths_realms_server_realm:"") + "";
            attrs.push({
              id: newId,
              inter_realm: services_kerberos_capaths_realms_inter_realm,
server_realm: services_kerberos_capaths_realms_server_realm,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms.length; i++) {
              if(services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms[i].server_realm !== services_kerberos_capaths_realms_server_realm ) {
                attrs.push(services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms[i]);
              }
            }
          }
        } else {
          attrs = services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms;
        }
        services_kerberos_capaths_realmsrowData.services_kerberos_capaths_realms = attrs;
        const data = {services_kerberos_capaths_realms: attrs};
        setservices_kerberos_capaths_realms(data.services_kerberos_capaths_realms);

        if(services_kerberos_capaths_realms_server_realm !== undefined && services_kerberos_capaths_realms_server_realm !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_kerberos_libdefaults_properties, setservices_kerberos_libdefaults_properties] = React.useState([]);
    const [fetchedservices_kerberos_libdefaults_properties, setFetchedservices_kerberos_libdefaults_properties] = React.useState(false);

    React.useEffect(() => {
      services_kerberos_libdefaults_propertiesloadGrid();
    }, [fetchedservices_kerberos_libdefaults_properties]);

    const services_kerberos_libdefaults_propertiesloadGrid = React.useCallback(async (services_kerberos_libdefaults_properties_name, services_kerberos_libdefaults_properties_value, add) => {
      try {
        var attrs = [];
        if(services_kerberos_libdefaults_properties_name) {
          if(add) {
            for(var i = 0; i < services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties.length; i++) {
              var tempId = ((services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].name)?services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].name:"") + "";
              if((window.services_kerberos_libdefaults_propertiesediting != true && window.services_kerberos_libdefaults_propertiesediting != "true") || tempId != window.services_kerberos_libdefaults_propertiesrowId) {
                attrs.push(services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i]);
              }
            }
            var newId = ((services_kerberos_libdefaults_properties_name)?services_kerberos_libdefaults_properties_name:"") + "";
            attrs.push({
              id: newId,
              name: services_kerberos_libdefaults_properties_name,
value: services_kerberos_libdefaults_properties_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties.length; i++) {
              if(services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].name !== services_kerberos_libdefaults_properties_name ) {
                attrs.push(services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i]);
              }
            }
          }
        } else {
          attrs = services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties;
        }
        services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties = attrs;
        const data = {services_kerberos_libdefaults_properties: attrs};
        setservices_kerberos_libdefaults_properties(data.services_kerberos_libdefaults_properties);

        if(services_kerberos_libdefaults_properties_name !== undefined && services_kerberos_libdefaults_properties_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_kerberos_realms, setservices_kerberos_realms] = React.useState([]);
    const [fetchedservices_kerberos_realms, setFetchedservices_kerberos_realms] = React.useState(false);

    React.useEffect(() => {
      services_kerberos_realmsloadGrid();
    }, [fetchedservices_kerberos_realms]);

    const services_kerberos_realmsloadGrid = React.useCallback(async (services_kerberos_realms_hostname, services_kerberos_realms_kdc, services_kerberos_realms_name, services_kerberos_realms_properties,add) => {
      try {
        var attrs = [];
        if(services_kerberos_realms_name) {
          if(add) {
            for(var i = 0; i < services_kerberos_realmsrowData.services_kerberos_realms.length; i++) {
              var tempId = ((services_kerberos_realmsrowData.services_kerberos_realms[i].name)?services_kerberos_realmsrowData.services_kerberos_realms[i].name:"") + "";
              if((window.services_kerberos_realmsediting != true && window.services_kerberos_realmsediting != "true") || tempId != window.services_kerberos_realmsrowId) {
                attrs.push(services_kerberos_realmsrowData.services_kerberos_realms[i]);
              }
            }
            var newId = ((services_kerberos_realms_name)?services_kerberos_realms_name:"") + "";
            attrs.push({
              id: newId,
              hostname: services_kerberos_realms_hostname,
kdc: services_kerberos_realms_kdc,
name: services_kerberos_realms_name,
properties: services_kerberos_realms_properties,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_kerberos_realmsrowData.services_kerberos_realms.length; i++) {
              if(services_kerberos_realmsrowData.services_kerberos_realms[i].name !== services_kerberos_realms_name ) {
                attrs.push(services_kerberos_realmsrowData.services_kerberos_realms[i]);
              }
            }
          }
        } else {
          attrs = services_kerberos_realmsrowData.services_kerberos_realms;
        }
        services_kerberos_realmsrowData.services_kerberos_realms = attrs;
        const data = {services_kerberos_realms: attrs};
        setservices_kerberos_realms(data.services_kerberos_realms);

        if(services_kerberos_realms_name !== undefined && services_kerberos_realms_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_kerberos_realms_properties, setservices_kerberos_realms_properties] = React.useState([]);
    const [fetchedservices_kerberos_realms_properties, setFetchedservices_kerberos_realms_properties] = React.useState(false);

    React.useEffect(() => {
      services_kerberos_realms_propertiesloadGrid();
    }, [fetchedservices_kerberos_realms_properties]);

    const services_kerberos_realms_propertiesloadGrid = React.useCallback(async (services_kerberos_realms_properties_name, services_kerberos_realms_properties_value, add) => {
      try {
        var attrs = [];
        if(services_kerberos_realms_properties_name) {
          if(add) {
            for(var i = 0; i < services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties.length; i++) {
              var tempId = ((services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties[i].name)?services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties[i].name:"") + "";
              if((window.services_kerberos_realms_propertiesediting != true && window.services_kerberos_realms_propertiesediting != "true") || tempId != window.services_kerberos_realms_propertiesrowId) {
                attrs.push(services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties[i]);
              }
            }
            var newId = ((services_kerberos_realms_properties_name)?services_kerberos_realms_properties_name:"") + "";
            attrs.push({
              id: newId,
              name: services_kerberos_realms_properties_name,
value: services_kerberos_realms_properties_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties.length; i++) {
              if(services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties[i].name !== services_kerberos_realms_properties_name ) {
                attrs.push(services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties[i]);
              }
            }
          }
        } else {
          attrs = services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties;
        }
        services_kerberos_realms_propertiesrowData.services_kerberos_realms_properties = attrs;
        const data = {services_kerberos_realms_properties: attrs};
        setservices_kerberos_realms_properties(data.services_kerberos_realms_properties);

        if(services_kerberos_realms_properties_name !== undefined && services_kerberos_realms_properties_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_redis_collections, setservices_redis_collections] = React.useState([]);
    const [fetchedservices_redis_collections, setFetchedservices_redis_collections] = React.useState(false);

    React.useEffect(() => {
      services_redis_collectionsloadGrid();
    }, [fetchedservices_redis_collections]);

    const services_redis_collectionsloadGrid = React.useCallback(async (services_redis_collections_connect_timeout, services_redis_collections_cross_domain_support_master_authn_server_url, services_redis_collections_cross_domain_support_master_session_code_lifetime, services_redis_collections_health_check_interval, services_redis_collections_idle_timeout, services_redis_collections_io_timeout, services_redis_collections_matching_host, services_redis_collections_max_pooled_connections, services_redis_collections_name, services_redis_collections_servers,add) => {
      try {
        var attrs = [];
        if(services_redis_collections_name) {
          if(add) {
            for(var i = 0; i < services_redis_collectionsrowData.services_redis_collections.length; i++) {
              var tempId = ((services_redis_collectionsrowData.services_redis_collections[i].name)?services_redis_collectionsrowData.services_redis_collections[i].name:"") + "";
              if((window.services_redis_collectionsediting != true && window.services_redis_collectionsediting != "true") || tempId != window.services_redis_collectionsrowId) {
                attrs.push(services_redis_collectionsrowData.services_redis_collections[i]);
              }
            }
            var newId = ((services_redis_collections_name)?services_redis_collections_name:"") + "";
            attrs.push({
              id: newId,
              connect_timeout: services_redis_collections_connect_timeout,
    cross_domain_support: {
master_authn_server_url: services_redis_collections_cross_domain_support_master_authn_server_url,
master_session_code_lifetime: services_redis_collections_cross_domain_support_master_session_code_lifetime,
    },
health_check_interval: services_redis_collections_health_check_interval,
idle_timeout: services_redis_collections_idle_timeout,
io_timeout: services_redis_collections_io_timeout,
matching_host: services_redis_collections_matching_host,
max_pooled_connections: services_redis_collections_max_pooled_connections,
name: services_redis_collections_name,
servers: services_redis_collections_servers,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_redis_collectionsrowData.services_redis_collections.length; i++) {
              if(services_redis_collectionsrowData.services_redis_collections[i].name !== services_redis_collections_name ) {
                attrs.push(services_redis_collectionsrowData.services_redis_collections[i]);
              }
            }
          }
        } else {
          attrs = services_redis_collectionsrowData.services_redis_collections;
        }
        services_redis_collectionsrowData.services_redis_collections = attrs;
        const data = {services_redis_collections: attrs};
        setservices_redis_collections(data.services_redis_collections);

        if(services_redis_collections_name !== undefined && services_redis_collections_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_redis_collections_servers, setservices_redis_collections_servers] = React.useState([]);
    const [fetchedservices_redis_collections_servers, setFetchedservices_redis_collections_servers] = React.useState(false);

    React.useEffect(() => {
      services_redis_collections_serversloadGrid();
    }, [fetchedservices_redis_collections_servers]);

    const services_redis_collections_serversloadGrid = React.useCallback(async (services_redis_collections_servers_host, services_redis_collections_servers_name, services_redis_collections_servers_password, services_redis_collections_servers_port, services_redis_collections_servers_ssl_sni, services_redis_collections_servers_username, services_redis_collections_servers_ssl_client_certificate,services_redis_collections_servers_ssl_trust_certificates,add) => {
      try {
        var attrs = [];
        if(services_redis_collections_servers_name) {
          if(add) {
            for(var i = 0; i < services_redis_collections_serversrowData.services_redis_collections_servers.length; i++) {
              var tempId = ((services_redis_collections_serversrowData.services_redis_collections_servers[i].name)?services_redis_collections_serversrowData.services_redis_collections_servers[i].name:"") + "";
              if((window.services_redis_collections_serversediting != true && window.services_redis_collections_serversediting != "true") || tempId != window.services_redis_collections_serversrowId) {
                attrs.push(services_redis_collections_serversrowData.services_redis_collections_servers[i]);
              }
            }
            var newId = ((services_redis_collections_servers_name)?services_redis_collections_servers_name:"") + "";
            attrs.push({
              id: newId,
              host: services_redis_collections_servers_host,
name: services_redis_collections_servers_name,
password: services_redis_collections_servers_password,
port: services_redis_collections_servers_port,
    ssl: {
client_certificate: services_redis_collections_servers_ssl_client_certificate,
sni: services_redis_collections_servers_ssl_sni,
trust_certificates: services_redis_collections_servers_ssl_trust_certificates,
    },
username: services_redis_collections_servers_username,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_redis_collections_serversrowData.services_redis_collections_servers.length; i++) {
              if(services_redis_collections_serversrowData.services_redis_collections_servers[i].name !== services_redis_collections_servers_name ) {
                attrs.push(services_redis_collections_serversrowData.services_redis_collections_servers[i]);
              }
            }
          }
        } else {
          attrs = services_redis_collections_serversrowData.services_redis_collections_servers;
        }
        services_redis_collections_serversrowData.services_redis_collections_servers = attrs;
        const data = {services_redis_collections_servers: attrs};
        setservices_redis_collections_servers(data.services_redis_collections_servers);

        if(services_redis_collections_servers_name !== undefined && services_redis_collections_servers_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_redis_collections_servers_ssl_client_certificate, setservices_redis_collections_servers_ssl_client_certificate] = React.useState([]);
    const [fetchedservices_redis_collections_servers_ssl_client_certificate, setFetchedservices_redis_collections_servers_ssl_client_certificate] = React.useState(false);

    React.useEffect(() => {
      services_redis_collections_servers_ssl_client_certificateloadGrid();
    }, [fetchedservices_redis_collections_servers_ssl_client_certificate]);

    const services_redis_collections_servers_ssl_client_certificateloadGrid = React.useCallback(async (services_redis_collections_servers_ssl_client_certificate_client_certificate, add) => {
      try {
        var attrs = [];
        if(services_redis_collections_servers_ssl_client_certificate_client_certificate) {
          if(add) {
            for(var i = 0; i < services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate.length; i++) {
              var tempId = ((services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate[i].client_certificate)?services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate[i].client_certificate:"") + "";
              if((window.services_redis_collections_servers_ssl_client_certificateediting != true && window.services_redis_collections_servers_ssl_client_certificateediting != "true") || tempId != window.services_redis_collections_servers_ssl_client_certificaterowId) {
                attrs.push(services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate[i]);
              }
            }
            var newId = ((services_redis_collections_servers_ssl_client_certificate_client_certificate)?services_redis_collections_servers_ssl_client_certificate_client_certificate:"") + "";
            attrs.push({
              id: newId,
              client_certificate: services_redis_collections_servers_ssl_client_certificate_client_certificate,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate.length; i++) {
              if(services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate[i].client_certificate !== services_redis_collections_servers_ssl_client_certificate_client_certificate ) {
                attrs.push(services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate[i]);
              }
            }
          }
        } else {
          attrs = services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate;
        }
        services_redis_collections_servers_ssl_client_certificaterowData.services_redis_collections_servers_ssl_client_certificate = attrs;
        const data = {services_redis_collections_servers_ssl_client_certificate: attrs};
        setservices_redis_collections_servers_ssl_client_certificate(data.services_redis_collections_servers_ssl_client_certificate);

        if(services_redis_collections_servers_ssl_client_certificate_client_certificate !== undefined && services_redis_collections_servers_ssl_client_certificate_client_certificate !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [services_redis_collections_servers_ssl_trust_certificates, setservices_redis_collections_servers_ssl_trust_certificates] = React.useState([]);
    const [fetchedservices_redis_collections_servers_ssl_trust_certificates, setFetchedservices_redis_collections_servers_ssl_trust_certificates] = React.useState(false);

    React.useEffect(() => {
      services_redis_collections_servers_ssl_trust_certificatesloadGrid();
    }, [fetchedservices_redis_collections_servers_ssl_trust_certificates]);

    const services_redis_collections_servers_ssl_trust_certificatesloadGrid = React.useCallback(async (services_redis_collections_servers_ssl_trust_certificates_trust_certificates, add) => {
      try {
        var attrs = [];
        if(services_redis_collections_servers_ssl_trust_certificates_trust_certificates) {
          if(add) {
            for(var i = 0; i < services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates.length; i++) {
              var tempId = ((services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates[i].trust_certificates)?services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates[i].trust_certificates:"") + "";
              if((window.services_redis_collections_servers_ssl_trust_certificatesediting != true && window.services_redis_collections_servers_ssl_trust_certificatesediting != "true") || tempId != window.services_redis_collections_servers_ssl_trust_certificatesrowId) {
                attrs.push(services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates[i]);
              }
            }
            var newId = ((services_redis_collections_servers_ssl_trust_certificates_trust_certificates)?services_redis_collections_servers_ssl_trust_certificates_trust_certificates:"") + "";
            attrs.push({
              id: newId,
              trust_certificates: services_redis_collections_servers_ssl_trust_certificates_trust_certificates,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates.length; i++) {
              if(services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates[i].trust_certificates !== services_redis_collections_servers_ssl_trust_certificates_trust_certificates ) {
                attrs.push(services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates[i]);
              }
            }
          }
        } else {
          attrs = services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates;
        }
        services_redis_collections_servers_ssl_trust_certificatesrowData.services_redis_collections_servers_ssl_trust_certificates = attrs;
        const data = {services_redis_collections_servers_ssl_trust_certificates: attrs};
        setservices_redis_collections_servers_ssl_trust_certificates(data.services_redis_collections_servers_ssl_trust_certificates);

        if(services_redis_collections_servers_ssl_trust_certificates_trust_certificates !== undefined && services_redis_collections_servers_ssl_trust_certificates_trust_certificates !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [services_credential_authentication_access_token_token, setservices_credential_authentication_access_token_token] = useState(''),
    updateservices_credential_authentication_access_token_token = useCallback((evt) => setservices_credential_authentication_access_token_token(evt.target.value), []);

    const [services_credential_authentication_ba_password, setservices_credential_authentication_ba_password] = useState(''),
    updateservices_credential_authentication_ba_password = useCallback((evt) => setservices_credential_authentication_ba_password(evt.target.value), []);

    const [services_credential_authentication_ba_username, setservices_credential_authentication_ba_username] = useState(''),
    updateservices_credential_authentication_ba_username = useCallback((evt) => setservices_credential_authentication_ba_username(evt.target.value), []);

    const [services_credential_authentication_sso_client_id, setservices_credential_authentication_sso_client_id] = useState(''),
    updateservices_credential_authentication_sso_client_id = useCallback((evt) => setservices_credential_authentication_sso_client_id(evt.target.value), []);

    const [services_credential_authentication_sso_client_secret, setservices_credential_authentication_sso_client_secret] = useState(''),
    updateservices_credential_authentication_sso_client_secret = useCallback((evt) => setservices_credential_authentication_sso_client_secret(evt.target.value), []);

    const [services_credential_authentication_sso_endpoint, setservices_credential_authentication_sso_endpoint] = useState(''),
    updateservices_credential_authentication_sso_endpoint = useCallback((evt) => setservices_credential_authentication_sso_endpoint(evt.target.value), []);

    const [services_credential_authentication_sso_payload, setservices_credential_authentication_sso_payload] = useState('basic'),
    updateservices_credential_authentication_sso_payload = useCallback((evt) => setservices_credential_authentication_sso_payload(evt.target.value), []);

    const [services_credential_enc_key, setservices_credential_enc_key] = useState(''),
    updateservices_credential_enc_key = useCallback((evt) => setservices_credential_enc_key(evt.target.value), []);

    const [services_credential_host, setservices_credential_host] = useState(''),
    updateservices_credential_host = useCallback((evt) => setservices_credential_host(evt.target.value), []);

    const [services_credential_name, setservices_credential_name] = useState(''),
    updateservices_credential_name = useCallback((evt) => {
      setservices_credential_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(services_credentialrowData.services_credential, setservices_credential_name_valid, setservices_credential_name_invalid_text, "Services Credential", "name", tempId);
    }, []);

    const [services_credential_name_valid, setservices_credential_name_valid] = useState(true);
    const [services_credential_name_invalid_text, setservices_credential_name_invalid_text] = useState("");


    const [services_credential_port, setservices_credential_port] = useState(''),
    updateservices_credential_port = useCallback((evt) => setservices_credential_port(evt.target.value), []);

    const [services_credential_proxy, setservices_credential_proxy] = useState(''),
    updateservices_credential_proxy = useCallback((evt) => setservices_credential_proxy(evt.target.value), []);

    const [services_credential_ssl_server_dn, setservices_credential_ssl_server_dn] = useState(''),
    updateservices_credential_ssl_server_dn = useCallback((evt) => setservices_credential_ssl_server_dn(evt.target.value), []);

    const [services_credential_ssl_sni, setservices_credential_ssl_sni] = useState(''),
    updateservices_credential_ssl_sni = useCallback((evt) => setservices_credential_ssl_sni(evt.target.value), []);

    const [services_credential_url_pattern, setservices_credential_url_pattern] = useState(''),
    updateservices_credential_url_pattern = useCallback((evt) => setservices_credential_url_pattern(evt.target.value), []);

    const [services_credential_user_attribute, setservices_credential_user_attribute] = useState('AZN_PRINCIPAL_ID'),
    updateservices_credential_user_attribute = useCallback((evt) => setservices_credential_user_attribute(evt.target.value), []);

    const [services_credential_user_attribute_encoding, setservices_credential_user_attribute_encoding] = useState('url'),
    updateservices_credential_user_attribute_encoding = useCallback((evt) => setservices_credential_user_attribute_encoding(evt.target.value), []);

    const [services_kerberos_capaths_client_realm, setservices_kerberos_capaths_client_realm] = useState(''),
    updateservices_kerberos_capaths_client_realm = useCallback((evt) => {
      setservices_kerberos_capaths_client_realm(evt.target.value);
      var tempId = evt.target.value;
      validateField(services_kerberos_capathsrowData.services_kerberos_capaths, setservices_kerberos_capaths_client_realm_valid, setservices_kerberos_capaths_client_realm_invalid_text, "Services Kerberos Capaths", "client_realm", tempId);
    }, []);

    const [services_kerberos_capaths_client_realm_valid, setservices_kerberos_capaths_client_realm_valid] = useState(true);
    const [services_kerberos_capaths_client_realm_invalid_text, setservices_kerberos_capaths_client_realm_invalid_text] = useState("");


    const [services_kerberos_keytab, setservices_kerberos_keytab] = useState(''),
    updateservices_kerberos_keytab = useCallback((evt) => setservices_kerberos_keytab(evt.target.value), []);

    const [services_kerberos_keytab_spn, setservices_kerberos_keytab_spn] = useState(''),
    updateservices_kerberos_keytab_spn = useCallback((evt) => setservices_kerberos_keytab_spn(evt.target.value), []);

    const [services_kerberos_libdefaults_properties_name, setservices_kerberos_libdefaults_properties_name] = useState(''),
    updateservices_kerberos_libdefaults_properties_name = useCallback((evt) => {
      setservices_kerberos_libdefaults_properties_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties, setservices_kerberos_libdefaults_properties_name_valid, setservices_kerberos_libdefaults_properties_name_invalid_text, "Services Kerberos Libdefaults Properties", "name", tempId);
    }, []);

    const [services_kerberos_libdefaults_properties_name_valid, setservices_kerberos_libdefaults_properties_name_valid] = useState(true);
    const [services_kerberos_libdefaults_properties_name_invalid_text, setservices_kerberos_libdefaults_properties_name_invalid_text] = useState("");


    const [services_kerberos_libdefaults_properties_value, setservices_kerberos_libdefaults_properties_value] = useState(''),
    updateservices_kerberos_libdefaults_properties_value = useCallback((evt) => setservices_kerberos_libdefaults_properties_value(evt.target.value), []);

    const [services_kerberos_realms_hostname, setservices_kerberos_realms_hostname] = useState(''),
    updateservices_kerberos_realms_hostname = useCallback((evt) => setservices_kerberos_realms_hostname(evt.target.value), []);

    const [services_kerberos_realms_kdc, setservices_kerberos_realms_kdc] = useState(''),
    updateservices_kerberos_realms_kdc = useCallback((evt) => setservices_kerberos_realms_kdc(evt.target.value), []);

    const [services_kerberos_realms_name, setservices_kerberos_realms_name] = useState(''),
    updateservices_kerberos_realms_name = useCallback((evt) => {
      setservices_kerberos_realms_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(services_kerberos_realmsrowData.services_kerberos_realms, setservices_kerberos_realms_name_valid, setservices_kerberos_realms_name_invalid_text, "Services Kerberos Realms", "name", tempId);
    }, []);

    const [services_kerberos_realms_name_valid, setservices_kerberos_realms_name_valid] = useState(true);
    const [services_kerberos_realms_name_invalid_text, setservices_kerberos_realms_name_invalid_text] = useState("");


    const [services_redis_collections_connect_timeout, setservices_redis_collections_connect_timeout] = useState(2),
    updateservices_redis_collections_connect_timeout = useCallback((evt) => {}, []);

    const [services_redis_collections_cross_domain_support_master_authn_server_url, setservices_redis_collections_cross_domain_support_master_authn_server_url] = useState(''),
    updateservices_redis_collections_cross_domain_support_master_authn_server_url = useCallback((evt) => setservices_redis_collections_cross_domain_support_master_authn_server_url(evt.target.value), []);

    const [services_redis_collections_cross_domain_support_master_session_code_lifetime, setservices_redis_collections_cross_domain_support_master_session_code_lifetime] = useState(30),
    updateservices_redis_collections_cross_domain_support_master_session_code_lifetime = useCallback((evt) => {}, []);

    const [services_redis_collections_health_check_interval, setservices_redis_collections_health_check_interval] = useState(10),
    updateservices_redis_collections_health_check_interval = useCallback((evt) => {}, []);

    const [services_redis_collections_idle_timeout, setservices_redis_collections_idle_timeout] = useState(10),
    updateservices_redis_collections_idle_timeout = useCallback((evt) => {}, []);

    const [services_redis_collections_io_timeout, setservices_redis_collections_io_timeout] = useState(30),
    updateservices_redis_collections_io_timeout = useCallback((evt) => {}, []);

    const [services_redis_collections_matching_host, setservices_redis_collections_matching_host] = useState(''),
    updateservices_redis_collections_matching_host = useCallback((evt) => setservices_redis_collections_matching_host(evt.target.value), []);

    const [services_redis_collections_max_pooled_connections, setservices_redis_collections_max_pooled_connections] = useState(50),
    updateservices_redis_collections_max_pooled_connections = useCallback((evt) => {}, []);

    const [services_redis_collections_name, setservices_redis_collections_name] = useState(''),
    updateservices_redis_collections_name = useCallback((evt) => {
      setservices_redis_collections_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(services_redis_collectionsrowData.services_redis_collections, setservices_redis_collections_name_valid, setservices_redis_collections_name_invalid_text, "Services Redis Collections", "name", tempId);
    }, []);

    const [services_redis_collections_name_valid, setservices_redis_collections_name_valid] = useState(true);
    const [services_redis_collections_name_invalid_text, setservices_redis_collections_name_invalid_text] = useState("");


    const [services_redis_default_collection, setservices_redis_default_collection] = useState(''),
    updateservices_redis_default_collection = useCallback((evt) => setservices_redis_default_collection(evt.target.value), []);

    const [services_redis_key_prefix, setservices_redis_key_prefix] = useState(''),
    updateservices_redis_key_prefix = useCallback((evt) => setservices_redis_key_prefix(evt.target.value), []);


  if(window.iagpage != "ServicesPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "ServicesPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < services_credentialrowData.services_credential.length; i++) {
        if(services_credentialrowData.services_credential[i].id === window.services_credentialrowId) {
        setservices_credential_authentication_access_token_token((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.access_token !== undefined && services_credentialrowData.services_credential[i].authentication.access_token.token !== undefined )?services_credentialrowData.services_credential[i].authentication.access_token.token:"");
        setservices_credential_authentication_ba_password((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.ba !== undefined && services_credentialrowData.services_credential[i].authentication.ba.password !== undefined )?services_credentialrowData.services_credential[i].authentication.ba.password:"");
        setservices_credential_authentication_ba_username((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.ba !== undefined && services_credentialrowData.services_credential[i].authentication.ba.username !== undefined )?services_credentialrowData.services_credential[i].authentication.ba.username:"");
        setservices_credential_authentication_sso_client_id((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.sso !== undefined && services_credentialrowData.services_credential[i].authentication.sso.client_id !== undefined )?services_credentialrowData.services_credential[i].authentication.sso.client_id:"");
        setservices_credential_authentication_sso_client_secret((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.sso !== undefined && services_credentialrowData.services_credential[i].authentication.sso.client_secret !== undefined )?services_credentialrowData.services_credential[i].authentication.sso.client_secret:"");
        setservices_credential_authentication_sso_endpoint((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.sso !== undefined && services_credentialrowData.services_credential[i].authentication.sso.endpoint !== undefined )?services_credentialrowData.services_credential[i].authentication.sso.endpoint:"");
        setservices_credential_authentication_sso_payload((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].authentication !== undefined && services_credentialrowData.services_credential[i].authentication.sso !== undefined && services_credentialrowData.services_credential[i].authentication.sso.payload !== undefined )?services_credentialrowData.services_credential[i].authentication.sso.payload:"");
        setservices_credential_enc_key((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].enc_key !== undefined )?services_credentialrowData.services_credential[i].enc_key:"");
        setservices_credential_host((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].host !== undefined )?services_credentialrowData.services_credential[i].host:"");
        setservices_credential_name((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].name !== undefined )?services_credentialrowData.services_credential[i].name:"");
        setservices_credential_port((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].port !== undefined )?services_credentialrowData.services_credential[i].port:"");
        setservices_credential_proxy((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].proxy !== undefined )?services_credentialrowData.services_credential[i].proxy:"");
        setservices_credential_ssl_server_dn((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].ssl !== undefined && services_credentialrowData.services_credential[i].ssl.server_dn !== undefined )?services_credentialrowData.services_credential[i].ssl.server_dn:"");
        setservices_credential_ssl_sni((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].ssl !== undefined && services_credentialrowData.services_credential[i].ssl.sni !== undefined )?services_credentialrowData.services_credential[i].ssl.sni:"");
        setservices_credential_url_pattern((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].url_pattern !== undefined )?services_credentialrowData.services_credential[i].url_pattern:"");
        setservices_credential_user_attribute((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].user_attribute !== undefined )?services_credentialrowData.services_credential[i].user_attribute:"");
        setservices_credential_user_attribute_encoding((services_credentialrowData.services_credential[i] !== undefined && services_credentialrowData.services_credential[i].user_attribute_encoding !== undefined )?services_credentialrowData.services_credential[i].user_attribute_encoding:"");
        }
      }

      for(var i = 0; i < services_kerberos_capathsrowData.services_kerberos_capaths.length; i++) {
        if(services_kerberos_capathsrowData.services_kerberos_capaths[i].id === window.services_kerberos_capathsrowId) {
        setservices_kerberos_capaths_client_realm((services_kerberos_capathsrowData.services_kerberos_capaths[i] !== undefined && services_kerberos_capathsrowData.services_kerberos_capaths[i].client_realm !== undefined )?services_kerberos_capathsrowData.services_kerberos_capaths[i].client_realm:"");
        }
      }

      for(var i = 0; i < services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties.length; i++) {
        if(services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].id === window.services_kerberos_libdefaults_propertiesrowId) {
        setservices_kerberos_libdefaults_properties_name((services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i] !== undefined && services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].name !== undefined )?services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].name:"");
        setservices_kerberos_libdefaults_properties_value((services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i] !== undefined && services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].value !== undefined )?services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties[i].value:"");
        }
      }

      for(var i = 0; i < services_kerberos_realmsrowData.services_kerberos_realms.length; i++) {
        if(services_kerberos_realmsrowData.services_kerberos_realms[i].id === window.services_kerberos_realmsrowId) {
        setservices_kerberos_realms_hostname((services_kerberos_realmsrowData.services_kerberos_realms[i] !== undefined && services_kerberos_realmsrowData.services_kerberos_realms[i].hostname !== undefined )?services_kerberos_realmsrowData.services_kerberos_realms[i].hostname:"");
        setservices_kerberos_realms_kdc((services_kerberos_realmsrowData.services_kerberos_realms[i] !== undefined && services_kerberos_realmsrowData.services_kerberos_realms[i].kdc !== undefined )?services_kerberos_realmsrowData.services_kerberos_realms[i].kdc:"");
        setservices_kerberos_realms_name((services_kerberos_realmsrowData.services_kerberos_realms[i] !== undefined && services_kerberos_realmsrowData.services_kerberos_realms[i].name !== undefined )?services_kerberos_realmsrowData.services_kerberos_realms[i].name:"");
        }
      }

      for(var i = 0; i < services_redis_collectionsrowData.services_redis_collections.length; i++) {
        if(services_redis_collectionsrowData.services_redis_collections[i].id === window.services_redis_collectionsrowId) {
        setservices_redis_collections_connect_timeout((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].connect_timeout !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].connect_timeout:"");
        setservices_redis_collections_cross_domain_support_master_authn_server_url((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].cross_domain_support !== undefined && services_redis_collectionsrowData.services_redis_collections[i].cross_domain_support.master_authn_server_url !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].cross_domain_support.master_authn_server_url:"");
        setservices_redis_collections_cross_domain_support_master_session_code_lifetime((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].cross_domain_support !== undefined && services_redis_collectionsrowData.services_redis_collections[i].cross_domain_support.master_session_code_lifetime !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].cross_domain_support.master_session_code_lifetime:"");
        setservices_redis_collections_health_check_interval((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].health_check_interval !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].health_check_interval:"");
        setservices_redis_collections_idle_timeout((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].idle_timeout !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].idle_timeout:"");
        setservices_redis_collections_io_timeout((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].io_timeout !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].io_timeout:"");
        setservices_redis_collections_matching_host((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].matching_host !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].matching_host:"");
        setservices_redis_collections_max_pooled_connections((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].max_pooled_connections !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].max_pooled_connections:"");
        setservices_redis_collections_name((services_redis_collectionsrowData.services_redis_collections[i] !== undefined && services_redis_collectionsrowData.services_redis_collections[i].name !== undefined )?services_redis_collectionsrowData.services_redis_collections[i].name:"");
        }
      }


      return true;
    };
    const [fetchedservices, setFetchedservices] = React.useState(false);
    React.useEffect(() => {
      getservices();
    }, [fetchedservices]);

    const getservices = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

            services_credentialrowData.services_credential = [];
              services_kerberos_capathsrowData.services_kerberos_capaths = [];
                services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties = [];
              services_kerberos_realmsrowData.services_kerberos_realms = [];
              services_redis_collectionsrowData.services_redis_collections = [];

        if(json !== undefined && json.services !== undefined ) {
          if(json !== undefined && json.services !== undefined && json.services.credential !== undefined ) {
            var newcredentials = [];
            for(var i = 0; i < json.services.credential.length; i++) {
              var newItem = {};
              var newauthentication = {};
              if(json !== undefined && json.services !== undefined && json.services.credential[i] !== undefined && json.services.credential[i].authentication !== undefined ) {
                var newaccess_token = {};
                if(json !== undefined && json.services !== undefined && json.services.credential[i] !== undefined && json.services.credential[i].authentication !== undefined && json.services.credential[i].authentication.access_token !== undefined ) {
                  newaccess_token["token"] = json.services.credential[i].authentication.access_token.token;
                }
                newauthentication["access_token"] = newaccess_token;
                var newba = {};
                if(json !== undefined && json.services !== undefined && json.services.credential[i] !== undefined && json.services.credential[i].authentication !== undefined && json.services.credential[i].authentication.ba !== undefined ) {
                  newba["password"] = json.services.credential[i].authentication.ba.password;
                  newba["username"] = json.services.credential[i].authentication.ba.username;
                }
                newauthentication["ba"] = newba;
                var newsso = {};
                if(json !== undefined && json.services !== undefined && json.services.credential[i] !== undefined && json.services.credential[i].authentication !== undefined && json.services.credential[i].authentication.sso !== undefined ) {
                  newsso["client_id"] = json.services.credential[i].authentication.sso.client_id;
                  newsso["client_secret"] = json.services.credential[i].authentication.sso.client_secret;
                  newsso["endpoint"] = json.services.credential[i].authentication.sso.endpoint;
                  newsso["payload"] = json.services.credential[i].authentication.sso.payload;
                }
                newauthentication["sso"] = newsso;
              }
              newItem["authentication"] = newauthentication;
              var tempId = ((json.services.credential[i].name)?json.services.credential[i].name:"");
              newItem["id"] = tempId;
              newItem["enc_key"] = json.services.credential[i].enc_key;
              newItem["host"] = json.services.credential[i].host;
              newItem["name"] = json.services.credential[i].name;
              newItem["port"] = json.services.credential[i].port;
              newItem["proxy"] = json.services.credential[i].proxy;
              var newssl = {};
              if(json !== undefined && json.services !== undefined && json.services.credential[i] !== undefined && json.services.credential[i].ssl !== undefined ) {
                if(json !== undefined && json.services !== undefined && json.services.credential[i] !== undefined && json.services.credential[i].ssl !== undefined && json.services.credential[i].ssl.certificate !== undefined ) {
                  var newcertificates = [];
                  for(var i2 = 0; i2 < json.services.credential[i].ssl.certificate.length; i2++) {
                      var newcertificate = {};
                      newcertificate["id"] = json.services.credential[i].ssl.certificate[i2];
                      newcertificate["certificate"] = json.services.credential[i].ssl.certificate[i2];
                      newcertificates.push(newcertificate);
                  }
                  newssl["certificate"] = newcertificates;
                  }
                newssl["server_dn"] = json.services.credential[i].ssl.server_dn;
                newssl["sni"] = json.services.credential[i].ssl.sni;
              }
              newItem["ssl"] = newssl;
              newItem["url_pattern"] = json.services.credential[i].url_pattern;
              newItem["user_attribute"] = json.services.credential[i].user_attribute;
              newItem["user_attribute_encoding"] = json.services.credential[i].user_attribute_encoding;
              services_credentialrowData.services_credential.push(newItem);
            }
            }
          var newkerberos = {};
          if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined ) {
            if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.capaths !== undefined ) {
              var newcapathss = [];
              for(var i = 0; i < json.services.kerberos.capaths.length; i++) {
                var newkerberos = {};
                var tempId = ((json.services.kerberos.capaths[i].client_realm)?json.services.kerberos.capaths[i].client_realm:"");
                newkerberos["id"] = tempId;
                newkerberos["client_realm"] = json.services.kerberos.capaths[i].client_realm;
                if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.capaths[i] !== undefined && json.services.kerberos.capaths[i].realms !== undefined ) {
                  var newrealmss = [];
                  for(var i2 = 0; i2 < json.services.kerberos.capaths[i].realms.length; i2++) {
                    var newkerberos = {};
                    var tempId = ((json.services.kerberos.capaths[i].realms[i2].server_realm)?json.services.kerberos.capaths[i].realms[i2].server_realm:"");
                    newkerberos["id"] = tempId;
                    newkerberos["inter_realm"] = json.services.kerberos.capaths[i].realms[i2].inter_realm;
                    newkerberos["server_realm"] = json.services.kerberos.capaths[i].realms[i2].server_realm;
                  }
                  newkerberos["realms"] = newrealmss;
                  }
              }
              services_kerberos_capathsrowData.services_kerberos_capaths.push(newkerberos);
              }
            if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.keytab !== undefined ) {
              setservices_kerberos_keytab(json.services.kerberos.keytab);
            }
            if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.keytab_spn !== undefined ) {
              setservices_kerberos_keytab_spn(json.services.kerberos.keytab_spn);
            }
            var newlibdefaults = {};
            if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.libdefaults !== undefined ) {
              if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.libdefaults !== undefined && json.services.kerberos.libdefaults.properties !== undefined ) {
                var newpropertiess = [];
                for(var i = 0; i < json.services.kerberos.libdefaults.properties.length; i++) {
                  var newlibdefaults = {};
                  var tempId = ((json.services.kerberos.libdefaults.properties[i].name)?json.services.kerberos.libdefaults.properties[i].name:"");
                  newlibdefaults["id"] = tempId;
                  newlibdefaults["name"] = json.services.kerberos.libdefaults.properties[i].name;
                  newlibdefaults["value"] = json.services.kerberos.libdefaults.properties[i].value;
                }
                services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties.push(newlibdefaults);
                }
            }
            newkerberos["libdefaults"] = newlibdefaults;
            if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.realms !== undefined ) {
              var newrealmss = [];
              for(var i = 0; i < json.services.kerberos.realms.length; i++) {
                var newkerberos = {};
                var tempId = ((json.services.kerberos.realms[i].name)?json.services.kerberos.realms[i].name:"");
                newkerberos["id"] = tempId;
                newkerberos["hostname"] = json.services.kerberos.realms[i].hostname;
                newkerberos["kdc"] = json.services.kerberos.realms[i].kdc;
                newkerberos["name"] = json.services.kerberos.realms[i].name;
                if(json !== undefined && json.services !== undefined && json.services.kerberos !== undefined && json.services.kerberos.realms[i] !== undefined && json.services.kerberos.realms[i].properties !== undefined ) {
                  var newpropertiess = [];
                  for(var i2 = 0; i2 < json.services.kerberos.realms[i].properties.length; i2++) {
                    var newkerberos = {};
                    var tempId = ((json.services.kerberos.realms[i].properties[i2].name)?json.services.kerberos.realms[i].properties[i2].name:"");
                    newkerberos["id"] = tempId;
                    newkerberos["name"] = json.services.kerberos.realms[i].properties[i2].name;
                    newkerberos["value"] = json.services.kerberos.realms[i].properties[i2].value;
                  }
                  newkerberos["properties"] = newpropertiess;
                  }
              }
              services_kerberos_realmsrowData.services_kerberos_realms.push(newkerberos);
              }
          }
          var newredis = {};
          if(json !== undefined && json.services !== undefined && json.services.redis !== undefined ) {
            if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.collections !== undefined ) {
              var newcollectionss = [];
              for(var i = 0; i < json.services.redis.collections.length; i++) {
                var newredis = {};
                var tempId = ((json.services.redis.collections[i].name)?json.services.redis.collections[i].name:"");
                newredis["id"] = tempId;
                newredis["connect_timeout"] = json.services.redis.collections[i].connect_timeout;
                var newcross_domain_support = {};
                if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.collections[i] !== undefined && json.services.redis.collections[i].cross_domain_support !== undefined ) {
                  newcross_domain_support["master_authn_server_url"] = json.services.redis.collections[i].cross_domain_support.master_authn_server_url;
                  newcross_domain_support["master_session_code_lifetime"] = json.services.redis.collections[i].cross_domain_support.master_session_code_lifetime;
                }
                newredis["cross_domain_support"] = newcross_domain_support;
                newredis["health_check_interval"] = json.services.redis.collections[i].health_check_interval;
                newredis["idle_timeout"] = json.services.redis.collections[i].idle_timeout;
                newredis["io_timeout"] = json.services.redis.collections[i].io_timeout;
                newredis["matching_host"] = json.services.redis.collections[i].matching_host;
                newredis["max_pooled_connections"] = json.services.redis.collections[i].max_pooled_connections;
                newredis["name"] = json.services.redis.collections[i].name;
                if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.collections[i] !== undefined && json.services.redis.collections[i].servers !== undefined ) {
                  var newserverss = [];
                  for(var i2 = 0; i2 < json.services.redis.collections[i].servers.length; i2++) {
                    var newredis = {};
                    var tempId = ((json.services.redis.collections[i].servers[i2].name)?json.services.redis.collections[i].servers[i2].name:"");
                    newredis["id"] = tempId;
                    newredis["host"] = json.services.redis.collections[i].servers[i2].host;
                    newredis["name"] = json.services.redis.collections[i].servers[i2].name;
                    newredis["password"] = json.services.redis.collections[i].servers[i2].password;
                    newredis["port"] = json.services.redis.collections[i].servers[i2].port;
                    var newssl = {};
                    if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.collections[i] !== undefined && json.services.redis.collections[i].servers[i2] !== undefined && json.services.redis.collections[i].servers[i2].ssl !== undefined ) {
                      if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.collections[i] !== undefined && json.services.redis.collections[i].servers[i2] !== undefined && json.services.redis.collections[i].servers[i2].ssl !== undefined && json.services.redis.collections[i].servers[i2].ssl.client_certificate !== undefined ) {
                        var newclient_certificates = [];
                        for(var i3 = 0; i3 < json.services.redis.collections[i].servers[i2].ssl.client_certificate.length; i3++) {
                            var newclient_certificate = {};
                            newclient_certificate["id"] = json.services.redis.collections[i].servers[i2].ssl.client_certificate[i3];
                            newclient_certificate["client_certificate"] = json.services.redis.collections[i].servers[i2].ssl.client_certificate[i3];
                            newclient_certificates.push(newclient_certificate);
                        }
                        newssl["client_certificate"] = newclient_certificates;
                        }
                      newssl["sni"] = json.services.redis.collections[i].servers[i2].ssl.sni;
                      if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.collections[i] !== undefined && json.services.redis.collections[i].servers[i2] !== undefined && json.services.redis.collections[i].servers[i2].ssl !== undefined && json.services.redis.collections[i].servers[i2].ssl.trust_certificates !== undefined ) {
                        var newtrust_certificatess = [];
                        for(var i3 = 0; i3 < json.services.redis.collections[i].servers[i2].ssl.trust_certificates.length; i3++) {
                            var newtrust_certificates = {};
                            newtrust_certificates["id"] = json.services.redis.collections[i].servers[i2].ssl.trust_certificates[i3];
                            newtrust_certificates["trust_certificates"] = json.services.redis.collections[i].servers[i2].ssl.trust_certificates[i3];
                            newtrust_certificatess.push(newtrust_certificates);
                        }
                        newssl["trust_certificates"] = newtrust_certificatess;
                        }
                    }
                    newredis["ssl"] = newssl;
                    newredis["username"] = json.services.redis.collections[i].servers[i2].username;
                  }
                  newredis["servers"] = newserverss;
                  }
              }
              services_redis_collectionsrowData.services_redis_collections.push(newredis);
              }
            if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.default_collection !== undefined ) {
              setservices_redis_default_collection(json.services.redis.default_collection);
            }
            if(json !== undefined && json.services !== undefined && json.services.redis !== undefined && json.services.redis.key_prefix !== undefined ) {
              setservices_redis_key_prefix(json.services.redis.key_prefix);
            }
          }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Services
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `services` node defines services within the Application Gateway configuration.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="servicesPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"services_tab" + idPrefix} defaultTab={"credential_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"credential_tab" + idPrefix}>Credential</Tab>
                <Tab tabFor={"kerberos_tab" + idPrefix}>Kerberos</Tab>
                <Tab tabFor={"redis_tab" + idPrefix}>Redis</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"kerberos_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading services_div" + idPrefix}>
                  <span className="iag_breadcrumb">Services : </span><br/>                  <h2>Kerberos Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="This configuration is used to describe a Kerberos configuration file which IAG can use to perform Kerberos Constrained Delegation as a means of authentication to a protected application">
                    <p>This configuration is used to describe a Kerberos configuration file which IAG can use to perform Kerberos Constrained Delegation as a means of authentication to a protected application.<br/>The Kerberos service must contain:<br/>  * keytab<br/>  * keytab_spn<br/>  * realms<br/>  * libdefaults<br/><br/>`keytab_spn` and `keytab` must correspond to the service principal name and generated key table for a user which IAG will authenticate itself as. This user must have permission to perform delegated authentication.<br/>This entry is an object and can be used to specify a single kerberos service.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div services_div" + idPrefix}>
                <div className= {"iag_form_elem services_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"services_kerberos_capaths_tooltip_id" + idPrefix} >capaths</h3><hr/>
</div>
          <ReactTooltip id={"services_kerberos_capaths_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Authentication paths for non-hierarchical cross-realm.<br/></div></ReactTooltip>

                <div id={"services_kerberos_capathsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem services_div" + idPrefix}>
                    <DataTable id={"services_kerberos_capathsTable" + idPrefix} isSortable
                        headers={services_kerberos_capathsheaderData}
                        rows={services_kerberos_capathsrowData.services_kerberos_capaths}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {services_kerberos_capathshandleAdd(idPrefix, [setservices_kerberos_capaths_client_realm(''),    setservices_kerberos_capaths_client_realm_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServiceskerberoscapathsDeleteModal row={row} loadGrid={services_kerberos_capathsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServiceskerberoscapathsEdit  data={services_kerberos_capathsrowData.services_kerberos_capaths} setData={setDataMain} row={row} loadGrid={services_kerberos_capathsloadGrid} dataLoad={dataLoad} editing={true} name={"services_kerberos_capaths"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_kerberos_capaths_client_realm={updateservices_kerberos_capaths_client_realm} services_kerberos_capaths_client_realm={services_kerberos_capaths_client_realm}
            services_kerberos_capaths_client_realm_valid={services_kerberos_capaths_client_realm_valid}
            services_kerberos_capaths_client_realm_invalid_text={services_kerberos_capaths_client_realm_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem services_div" + idPrefix}>
          <TextInput  value={services_kerberos_keytab}  id={"services_kerberos_keytab_id" + idPrefix}  data-tooltip-id={"services_kerberos_keytab_tooltip_id" + idPrefix}  labelText="Keytab" onChange={(evt) => { updateservices_kerberos_keytab(evt); handleChange(); }}/>
          <ReactTooltip id={"services_kerberos_keytab_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The Kerberos key table file which IAG will use to authenticate with the server.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem services_div" + idPrefix}>
          <TextInput  value={services_kerberos_keytab_spn}  id={"services_kerberos_keytab_spn_id" + idPrefix}  data-tooltip-id={"services_kerberos_keytab_spn_tooltip_id" + idPrefix}  labelText="Keytab SPN" onChange={(evt) => { updateservices_kerberos_keytab_spn(evt); handleChange(); }}/>
          <ReactTooltip id={"services_kerberos_keytab_spn_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The service principal name of the impersonating user when creating a Kerberos token. The service principal name can be determined by executing the Microsoft utility `setspn` (that is, setspn -L user, where user is the identity of the IAG account).<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem services_div" + idPrefix}>
  <h3>libdefaults</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem services_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"services_kerberos_libdefaults_properties_tooltip_id" + idPrefix} >Properties</h3><hr/>
</div>
          <ReactTooltip id={"services_kerberos_libdefaults_properties_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The properties to be added to the Kerberos libdefaults configuration. Each entry consists of a name and a value.<br/></div></ReactTooltip>

                <div id={"services_kerberos_libdefaults_propertiesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem services_div" + idPrefix}>
                    <DataTable id={"services_kerberos_libdefaults_propertiesTable" + idPrefix} isSortable
                        headers={services_kerberos_libdefaults_propertiesheaderData}
                        rows={services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {services_kerberos_libdefaults_propertieshandleAdd(idPrefix, [setservices_kerberos_libdefaults_properties_name(''),    setservices_kerberos_libdefaults_properties_name_valid(true),    setservices_kerberos_libdefaults_properties_value(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServiceskerberoslibdefaultspropertiesDeleteModal row={row} loadGrid={services_kerberos_libdefaults_propertiesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServiceskerberoslibdefaultspropertiesEdit  data={services_kerberos_libdefaults_propertiesrowData.services_kerberos_libdefaults_properties} setData={setDataMain} row={row} loadGrid={services_kerberos_libdefaults_propertiesloadGrid} dataLoad={dataLoad} editing={true} name={"services_kerberos_libdefaults_properties"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_kerberos_libdefaults_properties_name={updateservices_kerberos_libdefaults_properties_name} services_kerberos_libdefaults_properties_name={services_kerberos_libdefaults_properties_name}
            services_kerberos_libdefaults_properties_name_valid={services_kerberos_libdefaults_properties_name_valid}
            services_kerberos_libdefaults_properties_name_invalid_text={services_kerberos_libdefaults_properties_name_invalid_text}
            updateservices_kerberos_libdefaults_properties_value={updateservices_kerberos_libdefaults_properties_value} services_kerberos_libdefaults_properties_value={services_kerberos_libdefaults_properties_value}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>

                <div className= {"iag_form_elem services_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"services_kerberos_realms_tooltip_id" + idPrefix} >Realms</h3><hr/>
</div>
          <ReactTooltip id={"services_kerberos_realms_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Realm-specific contact information and settings associated with the Microsoft Windows Server to use for performing Kerberos impersonation.<br/></div></ReactTooltip>

                <div id={"services_kerberos_realmsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem services_div" + idPrefix}>
                    <DataTable id={"services_kerberos_realmsTable" + idPrefix} isSortable
                        headers={services_kerberos_realmsheaderData}
                        rows={services_kerberos_realmsrowData.services_kerberos_realms}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {services_kerberos_realmshandleAdd(idPrefix, [setservices_kerberos_realms_hostname(''),    setservices_kerberos_realms_kdc(''),    setservices_kerberos_realms_name(''),    setservices_kerberos_realms_name_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServiceskerberosrealmsDeleteModal row={row} loadGrid={services_kerberos_realmsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServiceskerberosrealmsEdit  data={services_kerberos_realmsrowData.services_kerberos_realms} setData={setDataMain} row={row} loadGrid={services_kerberos_realmsloadGrid} dataLoad={dataLoad} editing={true} name={"services_kerberos_realms"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_kerberos_realms_hostname={updateservices_kerberos_realms_hostname} services_kerberos_realms_hostname={services_kerberos_realms_hostname}
            updateservices_kerberos_realms_kdc={updateservices_kerberos_realms_kdc} services_kerberos_realms_kdc={services_kerberos_realms_kdc}
            updateservices_kerberos_realms_name={updateservices_kerberos_realms_name} services_kerberos_realms_name={services_kerberos_realms_name}
            services_kerberos_realms_name_valid={services_kerberos_realms_name_valid}
            services_kerberos_realms_name_invalid_text={services_kerberos_realms_name_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"credential_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading services_div" + idPrefix}>
                  <span className="iag_breadcrumb">Services : </span><br/>                  <h2>Credential Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div services_div" + idPrefix}>
                <div className= {"iag_form_elem services_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"services_credential_tooltip_id" + idPrefix} >Credential</h3><hr/>
</div>
          <ReactTooltip id={"services_credential_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This configuration is used to describe an external credential service which IAG can use to retrieve credentials for use in single sign-on to protected applications.<br/>Each credential service must contain:<br/>  * name<br/>  * enc_key<br/>  * host<br/>  * url_pattern<br/>  * user_attribute<br/><br/>This entry is an array and can be used to specify multiple credential services.<br/></div></ReactTooltip>

                <div id={"services_credentialTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem services_div" + idPrefix}>
                    <DataTable id={"services_credentialTable" + idPrefix} isSortable
                        headers={services_credentialheaderData}
                        rows={services_credentialrowData.services_credential}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {services_credentialhandleAdd(idPrefix, [setservices_credential_authentication_access_token_token(''),    setservices_credential_authentication_ba_password(''),    setservices_credential_authentication_ba_username(''),    setservices_credential_authentication_sso_client_id(''),    setservices_credential_authentication_sso_client_secret(''),    setservices_credential_authentication_sso_endpoint(''),    setservices_credential_authentication_sso_payload('basic'),    setservices_credential_enc_key(''),    setservices_credential_host(''),    setservices_credential_name(''),    setservices_credential_name_valid(true),    setservices_credential_port(''),    setservices_credential_proxy(''),    setservices_credential_ssl_server_dn(''),    setservices_credential_ssl_sni(''),    setservices_credential_url_pattern(''),    setservices_credential_user_attribute('AZN_PRINCIPAL_ID'),    setservices_credential_user_attribute_encoding('url'),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServicescredentialDeleteModal row={row} loadGrid={services_credentialloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServicescredentialEdit  data={services_credentialrowData.services_credential} setData={setDataMain} row={row} loadGrid={services_credentialloadGrid} dataLoad={dataLoad} editing={true} name={"services_credential"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_credential_authentication_access_token_token={updateservices_credential_authentication_access_token_token} services_credential_authentication_access_token_token={services_credential_authentication_access_token_token}
            updateservices_credential_authentication_ba_password={updateservices_credential_authentication_ba_password} services_credential_authentication_ba_password={services_credential_authentication_ba_password}
            updateservices_credential_authentication_ba_username={updateservices_credential_authentication_ba_username} services_credential_authentication_ba_username={services_credential_authentication_ba_username}
            updateservices_credential_authentication_sso_client_id={updateservices_credential_authentication_sso_client_id} services_credential_authentication_sso_client_id={services_credential_authentication_sso_client_id}
            updateservices_credential_authentication_sso_client_secret={updateservices_credential_authentication_sso_client_secret} services_credential_authentication_sso_client_secret={services_credential_authentication_sso_client_secret}
            updateservices_credential_authentication_sso_endpoint={updateservices_credential_authentication_sso_endpoint} services_credential_authentication_sso_endpoint={services_credential_authentication_sso_endpoint}
            updateservices_credential_authentication_sso_payload={updateservices_credential_authentication_sso_payload} services_credential_authentication_sso_payload={services_credential_authentication_sso_payload}
            updateservices_credential_enc_key={updateservices_credential_enc_key} services_credential_enc_key={services_credential_enc_key}
            updateservices_credential_host={updateservices_credential_host} services_credential_host={services_credential_host}
            updateservices_credential_name={updateservices_credential_name} services_credential_name={services_credential_name}
            services_credential_name_valid={services_credential_name_valid}
            services_credential_name_invalid_text={services_credential_name_invalid_text}
            updateservices_credential_port={updateservices_credential_port} services_credential_port={services_credential_port}
            updateservices_credential_proxy={updateservices_credential_proxy} services_credential_proxy={services_credential_proxy}
            updateservices_credential_ssl_server_dn={updateservices_credential_ssl_server_dn} services_credential_ssl_server_dn={services_credential_ssl_server_dn}
            updateservices_credential_ssl_sni={updateservices_credential_ssl_sni} services_credential_ssl_sni={services_credential_ssl_sni}
            updateservices_credential_url_pattern={updateservices_credential_url_pattern} services_credential_url_pattern={services_credential_url_pattern}
            updateservices_credential_user_attribute={updateservices_credential_user_attribute} services_credential_user_attribute={services_credential_user_attribute}
            updateservices_credential_user_attribute_encoding={updateservices_credential_user_attribute_encoding} services_credential_user_attribute_encoding={services_credential_user_attribute_encoding}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"redis_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading services_div" + idPrefix}>
                  <span className="iag_breadcrumb">Services : </span><br/>                  <h2>Redis Settings</h2><hr/>
                  Used to define the global configuration and server collections for  Redis.
                </div>
                <div className={"iag--simple-div services_div" + idPrefix}>
                <div className= {"iag_form_elem services_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"services_redis_collections_tooltip_id" + idPrefix} >Collections</h3><hr/>
</div>
          <ReactTooltip id={"services_redis_collections_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Used to define the configuration for a collection of replicated Redis servers.<br/></div></ReactTooltip>

                <div id={"services_redis_collectionsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem services_div" + idPrefix}>
                    <DataTable id={"services_redis_collectionsTable" + idPrefix} isSortable
                        headers={services_redis_collectionsheaderData}
                        rows={services_redis_collectionsrowData.services_redis_collections}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {services_redis_collectionshandleAdd(idPrefix, [setservices_redis_collections_connect_timeout(2),    setservices_redis_collections_cross_domain_support_master_authn_server_url(''),    setservices_redis_collections_cross_domain_support_master_session_code_lifetime(30),    setservices_redis_collections_health_check_interval(10),    setservices_redis_collections_idle_timeout(10),    setservices_redis_collections_io_timeout(30),    setservices_redis_collections_matching_host(''),    setservices_redis_collections_max_pooled_connections(50),    setservices_redis_collections_name(''),    setservices_redis_collections_name_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServicesrediscollectionsDeleteModal row={row} loadGrid={services_redis_collectionsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServicesrediscollectionsEdit  data={services_redis_collectionsrowData.services_redis_collections} setData={setDataMain} row={row} loadGrid={services_redis_collectionsloadGrid} dataLoad={dataLoad} editing={true} name={"services_redis_collections"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_redis_collections_connect_timeout={updateservices_redis_collections_connect_timeout} services_redis_collections_connect_timeout={services_redis_collections_connect_timeout}
            updateservices_redis_collections_cross_domain_support_master_authn_server_url={updateservices_redis_collections_cross_domain_support_master_authn_server_url} services_redis_collections_cross_domain_support_master_authn_server_url={services_redis_collections_cross_domain_support_master_authn_server_url}
            updateservices_redis_collections_cross_domain_support_master_session_code_lifetime={updateservices_redis_collections_cross_domain_support_master_session_code_lifetime} services_redis_collections_cross_domain_support_master_session_code_lifetime={services_redis_collections_cross_domain_support_master_session_code_lifetime}
            updateservices_redis_collections_health_check_interval={updateservices_redis_collections_health_check_interval} services_redis_collections_health_check_interval={services_redis_collections_health_check_interval}
            updateservices_redis_collections_idle_timeout={updateservices_redis_collections_idle_timeout} services_redis_collections_idle_timeout={services_redis_collections_idle_timeout}
            updateservices_redis_collections_io_timeout={updateservices_redis_collections_io_timeout} services_redis_collections_io_timeout={services_redis_collections_io_timeout}
            updateservices_redis_collections_matching_host={updateservices_redis_collections_matching_host} services_redis_collections_matching_host={services_redis_collections_matching_host}
            updateservices_redis_collections_max_pooled_connections={updateservices_redis_collections_max_pooled_connections} services_redis_collections_max_pooled_connections={services_redis_collections_max_pooled_connections}
            updateservices_redis_collections_name={updateservices_redis_collections_name} services_redis_collections_name={services_redis_collections_name}
            services_redis_collections_name_valid={services_redis_collections_name_valid}
            services_redis_collections_name_invalid_text={services_redis_collections_name_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem services_div" + idPrefix}>
          <TextInput  value={services_redis_default_collection}  id={"services_redis_default_collection_id" + idPrefix}  data-tooltip-id={"services_redis_default_collection_tooltip_id" + idPrefix}  labelText="Default Collection" onChange={(evt) => { updateservices_redis_default_collection(evt); handleChange(); }}/>
          <ReactTooltip id={"services_redis_default_collection_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The name of the default collection of Redis servers to be used.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem services_div" + idPrefix}>
          <TextInput  value={services_redis_key_prefix}  id={"services_redis_key_prefix_id" + idPrefix}  data-tooltip-id={"services_redis_key_prefix_tooltip_id" + idPrefix}  labelText="Key Prefix" onChange={(evt) => { updateservices_redis_key_prefix(evt); handleChange(); }}/>
          <ReactTooltip id={"services_redis_key_prefix_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The key prefix for all data which is stored on the Redis server.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <ServicescredentialAdd loadGrid={services_credentialloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateservices_credential_authentication_access_token_token={updateservices_credential_authentication_access_token_token} services_credential_authentication_access_token_token={services_credential_authentication_access_token_token}
            updateservices_credential_authentication_ba_password={updateservices_credential_authentication_ba_password} services_credential_authentication_ba_password={services_credential_authentication_ba_password}
            updateservices_credential_authentication_ba_username={updateservices_credential_authentication_ba_username} services_credential_authentication_ba_username={services_credential_authentication_ba_username}
            updateservices_credential_authentication_sso_client_id={updateservices_credential_authentication_sso_client_id} services_credential_authentication_sso_client_id={services_credential_authentication_sso_client_id}
            updateservices_credential_authentication_sso_client_secret={updateservices_credential_authentication_sso_client_secret} services_credential_authentication_sso_client_secret={services_credential_authentication_sso_client_secret}
            updateservices_credential_authentication_sso_endpoint={updateservices_credential_authentication_sso_endpoint} services_credential_authentication_sso_endpoint={services_credential_authentication_sso_endpoint}
            updateservices_credential_authentication_sso_payload={updateservices_credential_authentication_sso_payload} services_credential_authentication_sso_payload={services_credential_authentication_sso_payload}
            updateservices_credential_enc_key={updateservices_credential_enc_key} services_credential_enc_key={services_credential_enc_key}
            updateservices_credential_host={updateservices_credential_host} services_credential_host={services_credential_host}
            updateservices_credential_name={updateservices_credential_name} services_credential_name={services_credential_name}
            services_credential_name_valid={services_credential_name_valid}
            services_credential_name_invalid_text={services_credential_name_invalid_text}
            updateservices_credential_port={updateservices_credential_port} services_credential_port={services_credential_port}
            updateservices_credential_proxy={updateservices_credential_proxy} services_credential_proxy={services_credential_proxy}
            updateservices_credential_ssl_server_dn={updateservices_credential_ssl_server_dn} services_credential_ssl_server_dn={services_credential_ssl_server_dn}
            updateservices_credential_ssl_sni={updateservices_credential_ssl_sni} services_credential_ssl_sni={services_credential_ssl_sni}
            updateservices_credential_url_pattern={updateservices_credential_url_pattern} services_credential_url_pattern={services_credential_url_pattern}
            updateservices_credential_user_attribute={updateservices_credential_user_attribute} services_credential_user_attribute={services_credential_user_attribute}
            updateservices_credential_user_attribute_encoding={updateservices_credential_user_attribute_encoding} services_credential_user_attribute_encoding={services_credential_user_attribute_encoding}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServicescredentialEdit  loadGrid={services_credentialloadGrid} dataLoad={dataLoad} name={"services_credential"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_credential_authentication_access_token_token={updateservices_credential_authentication_access_token_token} services_credential_authentication_access_token_token={services_credential_authentication_access_token_token}
            updateservices_credential_authentication_ba_password={updateservices_credential_authentication_ba_password} services_credential_authentication_ba_password={services_credential_authentication_ba_password}
            updateservices_credential_authentication_ba_username={updateservices_credential_authentication_ba_username} services_credential_authentication_ba_username={services_credential_authentication_ba_username}
            updateservices_credential_authentication_sso_client_id={updateservices_credential_authentication_sso_client_id} services_credential_authentication_sso_client_id={services_credential_authentication_sso_client_id}
            updateservices_credential_authentication_sso_client_secret={updateservices_credential_authentication_sso_client_secret} services_credential_authentication_sso_client_secret={services_credential_authentication_sso_client_secret}
            updateservices_credential_authentication_sso_endpoint={updateservices_credential_authentication_sso_endpoint} services_credential_authentication_sso_endpoint={services_credential_authentication_sso_endpoint}
            updateservices_credential_authentication_sso_payload={updateservices_credential_authentication_sso_payload} services_credential_authentication_sso_payload={services_credential_authentication_sso_payload}
            updateservices_credential_enc_key={updateservices_credential_enc_key} services_credential_enc_key={services_credential_enc_key}
            updateservices_credential_host={updateservices_credential_host} services_credential_host={services_credential_host}
            updateservices_credential_name={updateservices_credential_name} services_credential_name={services_credential_name}
            services_credential_name_valid={services_credential_name_valid}
            services_credential_name_invalid_text={services_credential_name_invalid_text}
            updateservices_credential_port={updateservices_credential_port} services_credential_port={services_credential_port}
            updateservices_credential_proxy={updateservices_credential_proxy} services_credential_proxy={services_credential_proxy}
            updateservices_credential_ssl_server_dn={updateservices_credential_ssl_server_dn} services_credential_ssl_server_dn={services_credential_ssl_server_dn}
            updateservices_credential_ssl_sni={updateservices_credential_ssl_sni} services_credential_ssl_sni={services_credential_ssl_sni}
            updateservices_credential_url_pattern={updateservices_credential_url_pattern} services_credential_url_pattern={services_credential_url_pattern}
            updateservices_credential_user_attribute={updateservices_credential_user_attribute} services_credential_user_attribute={services_credential_user_attribute}
            updateservices_credential_user_attribute_encoding={updateservices_credential_user_attribute_encoding} services_credential_user_attribute_encoding={services_credential_user_attribute_encoding}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServiceskerberoscapathsAdd loadGrid={services_kerberos_capathsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateservices_kerberos_capaths_client_realm={updateservices_kerberos_capaths_client_realm} services_kerberos_capaths_client_realm={services_kerberos_capaths_client_realm}
            services_kerberos_capaths_client_realm_valid={services_kerberos_capaths_client_realm_valid}
            services_kerberos_capaths_client_realm_invalid_text={services_kerberos_capaths_client_realm_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServiceskerberoscapathsEdit  loadGrid={services_kerberos_capathsloadGrid} dataLoad={dataLoad} name={"services_kerberos_capaths"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_kerberos_capaths_client_realm={updateservices_kerberos_capaths_client_realm} services_kerberos_capaths_client_realm={services_kerberos_capaths_client_realm}
            services_kerberos_capaths_client_realm_valid={services_kerberos_capaths_client_realm_valid}
            services_kerberos_capaths_client_realm_invalid_text={services_kerberos_capaths_client_realm_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServiceskerberoslibdefaultspropertiesAdd loadGrid={services_kerberos_libdefaults_propertiesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateservices_kerberos_libdefaults_properties_name={updateservices_kerberos_libdefaults_properties_name} services_kerberos_libdefaults_properties_name={services_kerberos_libdefaults_properties_name}
            services_kerberos_libdefaults_properties_name_valid={services_kerberos_libdefaults_properties_name_valid}
            services_kerberos_libdefaults_properties_name_invalid_text={services_kerberos_libdefaults_properties_name_invalid_text}
            updateservices_kerberos_libdefaults_properties_value={updateservices_kerberos_libdefaults_properties_value} services_kerberos_libdefaults_properties_value={services_kerberos_libdefaults_properties_value}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServiceskerberoslibdefaultspropertiesEdit  loadGrid={services_kerberos_libdefaults_propertiesloadGrid} dataLoad={dataLoad} name={"services_kerberos_libdefaults_properties"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_kerberos_libdefaults_properties_name={updateservices_kerberos_libdefaults_properties_name} services_kerberos_libdefaults_properties_name={services_kerberos_libdefaults_properties_name}
            services_kerberos_libdefaults_properties_name_valid={services_kerberos_libdefaults_properties_name_valid}
            services_kerberos_libdefaults_properties_name_invalid_text={services_kerberos_libdefaults_properties_name_invalid_text}
            updateservices_kerberos_libdefaults_properties_value={updateservices_kerberos_libdefaults_properties_value} services_kerberos_libdefaults_properties_value={services_kerberos_libdefaults_properties_value}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServiceskerberosrealmsAdd loadGrid={services_kerberos_realmsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateservices_kerberos_realms_hostname={updateservices_kerberos_realms_hostname} services_kerberos_realms_hostname={services_kerberos_realms_hostname}
            updateservices_kerberos_realms_kdc={updateservices_kerberos_realms_kdc} services_kerberos_realms_kdc={services_kerberos_realms_kdc}
            updateservices_kerberos_realms_name={updateservices_kerberos_realms_name} services_kerberos_realms_name={services_kerberos_realms_name}
            services_kerberos_realms_name_valid={services_kerberos_realms_name_valid}
            services_kerberos_realms_name_invalid_text={services_kerberos_realms_name_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServiceskerberosrealmsEdit  loadGrid={services_kerberos_realmsloadGrid} dataLoad={dataLoad} name={"services_kerberos_realms"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_kerberos_realms_hostname={updateservices_kerberos_realms_hostname} services_kerberos_realms_hostname={services_kerberos_realms_hostname}
            updateservices_kerberos_realms_kdc={updateservices_kerberos_realms_kdc} services_kerberos_realms_kdc={services_kerberos_realms_kdc}
            updateservices_kerberos_realms_name={updateservices_kerberos_realms_name} services_kerberos_realms_name={services_kerberos_realms_name}
            services_kerberos_realms_name_valid={services_kerberos_realms_name_valid}
            services_kerberos_realms_name_invalid_text={services_kerberos_realms_name_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServicesrediscollectionsAdd loadGrid={services_redis_collectionsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateservices_redis_collections_connect_timeout={updateservices_redis_collections_connect_timeout} services_redis_collections_connect_timeout={services_redis_collections_connect_timeout}
            updateservices_redis_collections_cross_domain_support_master_authn_server_url={updateservices_redis_collections_cross_domain_support_master_authn_server_url} services_redis_collections_cross_domain_support_master_authn_server_url={services_redis_collections_cross_domain_support_master_authn_server_url}
            updateservices_redis_collections_cross_domain_support_master_session_code_lifetime={updateservices_redis_collections_cross_domain_support_master_session_code_lifetime} services_redis_collections_cross_domain_support_master_session_code_lifetime={services_redis_collections_cross_domain_support_master_session_code_lifetime}
            updateservices_redis_collections_health_check_interval={updateservices_redis_collections_health_check_interval} services_redis_collections_health_check_interval={services_redis_collections_health_check_interval}
            updateservices_redis_collections_idle_timeout={updateservices_redis_collections_idle_timeout} services_redis_collections_idle_timeout={services_redis_collections_idle_timeout}
            updateservices_redis_collections_io_timeout={updateservices_redis_collections_io_timeout} services_redis_collections_io_timeout={services_redis_collections_io_timeout}
            updateservices_redis_collections_matching_host={updateservices_redis_collections_matching_host} services_redis_collections_matching_host={services_redis_collections_matching_host}
            updateservices_redis_collections_max_pooled_connections={updateservices_redis_collections_max_pooled_connections} services_redis_collections_max_pooled_connections={services_redis_collections_max_pooled_connections}
            updateservices_redis_collections_name={updateservices_redis_collections_name} services_redis_collections_name={services_redis_collections_name}
            services_redis_collections_name_valid={services_redis_collections_name_valid}
            services_redis_collections_name_invalid_text={services_redis_collections_name_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServicesrediscollectionsEdit  loadGrid={services_redis_collectionsloadGrid} dataLoad={dataLoad} name={"services_redis_collections"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateservices_redis_collections_connect_timeout={updateservices_redis_collections_connect_timeout} services_redis_collections_connect_timeout={services_redis_collections_connect_timeout}
            updateservices_redis_collections_cross_domain_support_master_authn_server_url={updateservices_redis_collections_cross_domain_support_master_authn_server_url} services_redis_collections_cross_domain_support_master_authn_server_url={services_redis_collections_cross_domain_support_master_authn_server_url}
            updateservices_redis_collections_cross_domain_support_master_session_code_lifetime={updateservices_redis_collections_cross_domain_support_master_session_code_lifetime} services_redis_collections_cross_domain_support_master_session_code_lifetime={services_redis_collections_cross_domain_support_master_session_code_lifetime}
            updateservices_redis_collections_health_check_interval={updateservices_redis_collections_health_check_interval} services_redis_collections_health_check_interval={services_redis_collections_health_check_interval}
            updateservices_redis_collections_idle_timeout={updateservices_redis_collections_idle_timeout} services_redis_collections_idle_timeout={services_redis_collections_idle_timeout}
            updateservices_redis_collections_io_timeout={updateservices_redis_collections_io_timeout} services_redis_collections_io_timeout={services_redis_collections_io_timeout}
            updateservices_redis_collections_matching_host={updateservices_redis_collections_matching_host} services_redis_collections_matching_host={services_redis_collections_matching_host}
            updateservices_redis_collections_max_pooled_connections={updateservices_redis_collections_max_pooled_connections} services_redis_collections_max_pooled_connections={services_redis_collections_max_pooled_connections}
            updateservices_redis_collections_name={updateservices_redis_collections_name} services_redis_collections_name={services_redis_collections_name}
            services_redis_collections_name_valid={services_redis_collections_name_valid}
            services_redis_collections_name_invalid_text={services_redis_collections_name_invalid_text}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default ServicesPage;
